import React from "react";
import css from "../styles";

let DragSource = require('react-dnd').DragSource;
let DropTarget = require('react-dnd').DropTarget;

/*React DND Functions*/
let rowSource = {
    beginDrag: function (props) {
        return { id: props.id };
    }
};

let rowTarget = {
    hover: function (props, monitor) {
        let draggedId = monitor.getItem().id;
        if (draggedId !== props.id) {
            props.moveRow(draggedId, props.id, props.row.user);
        }
    }
};

let sourceCollect = function(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

let targetCollect = function(connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
};
/*End React DND Functions*/

class ProjectConfigRow extends React.Component{
    constructor(props) {
        super(props);

        if (!this.props.row.minLength) {
          if (this.props.row.min) {
            this.props.row.minLength = this.props.row.min;
          }
        }

        if (!this.props.row.maxLength) {
          if (this.props.row.max)
            this.props.row.maxLength = this.props.row.max;
        }
    }

    onRowDelete(evt) {
        const target = evt.currentTarget;
        this.props.onRowDelete(target.getAttribute("rowtype"), this.props.row);
    }
    
    render() {
        let opacity = this.props.isDragging ? 0 : 1;
        let connectDragSource= this.props.connectDragSource;
        let connectDropTarget = this.props.connectDropTarget;
        const rowData = this.props.row;
        let delBtn;
        let row;

        let allowSort = ["Speaker ID"];

        let choicesDisabled = false;
        let typeDisabled = false;
        let minMaxDisabled = false;
        let mirrorDisabled = true;

        if (rowData.user == "caller") {
          if (rowData.title != "Speaker ID")
            mirrorDisabled = false;
        }

        if (rowData.disableType === 1)
          choicesDisabled = typeDisabled = minMaxDisabled = true;
        else if(rowData.disableType === 2) //choice enabled
          typeDisabled = minMaxDisabled = true;
        else if(rowData.disableType === 3) //type minmax enabled
          choicesDisabled = true;
        else if(rowData.disableType === 4) //minmax enabled
          typeDisabled = choicesDisabled = true;

        let options = [];

        if (rowData.choices)
          rowData.choices.map(item =>
            options.push(<option key={`${rowData.id}:${item.value}`} value={item.value}>{item.label} - {item.value}</option>)
          );

        if (!rowData.admin_fixed || allowSort.includes(rowData.title)) {
          //add delete button
          delBtn = (<td style={css.center, css.tdNoBorder}>
                  <button rowtype={rowData.user} onClick={this.onRowDelete.bind(this)} className="btn btn-danger">
                    <i className="fa fa-times" />
                  </button>
              </td>);
        }

        row = (<tr className="eachRow" style={{opacity: opacity}, css.tr}>
                  <td>
                    <input type='text' 
                        name="title" 
                        rowtype={rowData.user}
                        id={rowData.id}
                        value={rowData.title}
                        onChange={this.props.onTableUpdate} 
                        className="form-control pull-right"/>
                  </td>
                  <td>
                    <select name="type" 
                        id={rowData.id}
                        rowtype={rowData.user}
                        value={rowData.type}
                        onChange={this.props.onTableUpdate}
                        disabled={typeDisabled}
                        className="form-control pull-right">
                        <option value="string">String</option>
                        <option value="number">Number</option>
                    </select>
                  </td>
                  <td>
                    <div className="col-md-10" style={{paddingLeft: 0}}>
                    <select
                      name="choices" 
                      id={rowData.id}
                      value={rowData.selectedChoice}
                      rowtype={rowData.user}
                      onChange={this.props.onTableUpdate}
                      style={css.choicesDelBtn}
                      disabled={choicesDisabled}
                      className="form-control pull-right">
                        {options}
                        <option key="option:blank" value="option:blank">-----</option>
                        <option key="option:add-new" value="option:add-new">Add new...</option>
                    </select>
                    </div>
                    <div className="col-md-2" style={{marginTop: "8px"}}>
                    <button 
                      type="button" 
                      className="btn btn-xs btn-danger pull-right"
                      onClick={() => this.props.onDeleteChoicesClicked(this, rowData.id, rowData.user)}
                      disabled={choicesDisabled}
                    >
                      <i className="fa fa-minus" />
                    </button>
                    </div>
                  </td>
                  <td>
                    <input className="form-check-input" 
                          type="checkbox" 
                          name="mirror"
                          checked={rowData.mirror}
                          disabled={mirrorDisabled}
                          rowtype={rowData.user}
                          onChange={this.props.onTableUpdate}
                          id={rowData.id} />
                  </td>
                  <td>
                    <input type='text' 
                        name="minLength" 
                        id={rowData.id}
                        rowtype={rowData.user}
                        value={rowData.minLength}
                        onChange={this.props.onTableUpdate}
                        disabled={minMaxDisabled}
                        className="form-control pull-right"/>
                  </td>
                  <td>
                    <input type='text' 
                        name="maxLength" 
                        id={rowData.id}
                        rowtype={rowData.user}
                        value={rowData.maxLength}
                        onChange={this.props.onTableUpdate}
                        disabled={minMaxDisabled}
                        className="form-control pull-right"/>
                  </td>
                  {delBtn}
              </tr>
            );

        if (!rowData.admin_fixed || allowSort.includes(rowData.title)) {
          //create row with reorder function
          row = (connectDragSource(connectDropTarget(row)));
        }

        return row;
    }
}

const source = DragSource('row', rowSource, sourceCollect)(ProjectConfigRow);
const row = DropTarget('row', rowTarget, targetCollect)(source);

export default row;


// WEBPACK FOOTER //
// ./src/views/projectconfig/components/ProjectConfigRow.js